import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: Error) {
        // eslint-disable-next-line no-console
        console.error(error);
        Sentry.captureException(error);
    }
}
